/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Default_HeadlineInputs */

const en_cta_default_headline = /** @type {(inputs: Cta_Default_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start With A Clear U.S. Plan`)
};

const pt_cta_default_headline = /** @type {(inputs: Cta_Default_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece Com Um Plano Claro para os EUA`)
};

const es_cta_default_headline = /** @type {(inputs: Cta_Default_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comience Con Un Plan Claro para EE. UU.`)
};

/**
* | output |
* | --- |
* | "Start With A Clear U.S. Plan" |
*
* @param {Cta_Default_HeadlineInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const cta_default_headline = /** @type {((inputs?: Cta_Default_HeadlineInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Default_HeadlineInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_cta_default_headline(inputs)
	if (locale === "es") return es_cta_default_headline(inputs)
	return en_cta_default_headline(inputs)
});